import { Box, Button, Dialog, DialogActions, DialogTitle, Stack, TextField } from '@mui/material'
import { FormEvent, FormEventHandler, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { InstallerPasswordData } from '../../types/auth'
import { CustomSwitch } from '../atoms/CustomSwitch'
import { Safety } from '../../classes/Safety'
import { INSTALLER_PASSWORD } from '../../types/constants'
import { useApp } from '../../hooks/useApp'

export function InstallerPasswordForm(): React.ReactElement {

  const app = useApp()
  const { t } = useTranslation()
  const [openInstallerPanel, setOpenInstallerPanel] = useState(false)
  const [wrongPassword, setWrongPassword] = useState(false)

  const onSubmit: FormEventHandler<HTMLFormElement> = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)

    const data: InstallerPasswordData = {
      installer_password: '',
    }

    for (const [, value] of formData) {
      data.installer_password = value as string
    }

    if (data.installer_password === INSTALLER_PASSWORD) {
      Safety.set('installer-level', true)
      setWrongPassword(false)
      const form: HTMLFormElement = document.getElementById('installer-setting') as HTMLFormElement
      form.reset()
      setOpenInstallerPanel(false)
      app.setInstallerLevel(true)
    } else {
      setWrongPassword(true)
    }
  }

  const handleToggleInstallerLevel = () => {
    if (app.installerLevel) {
      Safety.set('installer-level', undefined)
      app.setInstallerLevel(false)
    } else {
      setOpenInstallerPanel(true)
    }
  }

  const handleCloseInstallerPanel = () => {
    setOpenInstallerPanel(false)
  }

  return (
    <Box >
        <Box data-cy='box-Installer level'>
          <CustomSwitch onClick={handleToggleInstallerLevel} data-cy='switch-Installer setting' sx={{ mr: '1rem' }} checked={app.installerLevel}/>
          <Trans>Allow installer level settings</Trans>
        </Box>

        <Dialog open={!!openInstallerPanel} onClose={() => setOpenInstallerPanel(false)}>
            <form id="installer-setting" onSubmit={onSubmit}>
                <DialogTitle sx={{ backgroundColor: 'blue' }}><Trans>Installer Level Settings</Trans></DialogTitle>
                <Box sx={{ p: 2 }}>
                    <Trans>Please enter installer password. Password is 1234</Trans>
                    <TextField
                        data-cy='text-Installer password'
                        margin="normal"
                        fullWidth
                        name="installer-password"
                        error={wrongPassword}
                        label={t('Installer Password?')}
                        id="installer-password"
                        helperText={wrongPassword ? t('Wrong password!') : ''}
                    />
                </Box>
                <DialogActions>
                    <Stack direction="row" spacing={2} sx={{ m: 2 }}>
                        <Button color="primary" onClick={handleCloseInstallerPanel}><Trans>Cancel</Trans></Button>
                        <Button data-cy="button-Installer level OK" color="secondary" type='submit'><Trans>OK</Trans></Button>
                    </Stack>
                </DialogActions>
            </form>
        </Dialog>
    </Box>
  )
}
